import { createSlice } from "@reduxjs/toolkit";

import { addProfessionalDetailsChefAPI } from "../../../../api/chef";
import { sliceHandler } from "../../utils";

const addProfessionalDetailsChef = createSlice(
    sliceHandler({
        name: 'addProfessionalDetailsChef',
        action: 'addProfessionalDetailsChefSlice',
        success: 'addProfessionalDetailsChefSliceSuccess',
        failure: 'addProfessionalDetailsChefSliceFailure',
        reset: 'addProfessionalDetailsChefSliceReset'
    })
);

const addProfessionalDetailsChefAction: any = addProfessionalDetailsChef.actions;
const addProfessionalDetailsChefHandler = (data: any) => async (dispatch: any) => {
    try {
        dispatch(addProfessionalDetailsChefAction.addProfessionalDetailsChefSlice());
        const response: any = await addProfessionalDetailsChefAPI(data);
        dispatch(addProfessionalDetailsChefAction.addProfessionalDetailsChefSliceSuccess(response));
    } catch (e: any) {
        dispatch(addProfessionalDetailsChefAction.addProfessionalDetailsChefSliceFailure(e?.response?.data));
    }
};

export {
    addProfessionalDetailsChefAction,
    addProfessionalDetailsChefHandler,
}
export default addProfessionalDetailsChef.reducer;